import ScrollByDrag from './ScrollByDrag';

export default ScrollByDrag;
